import React, { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { FirmFilters } from '@/services/types/firms-types';

import { useFirmsList } from '../hooks';
import { FirmsTable } from '../list';

export const FirmsListPage: React.FC = () => {
  const navigate = useNavigate();

  // State for filters and pagination
  const [filters, setFilters] = useState<FirmFilters>({
    search: '',
    status: 'all',
    sortBy: 'updated_at',
    sortDirection: 'desc',
  });

  // Load firms data using custom hook
  const { firms, isLoading } = useFirmsList(filters);

  // Handler for search changes
  const handleSearchChange = useCallback((value: string) => {
    setFilters((prev) => ({
      ...prev,
      search: value,
    }));
  }, []);

  // Handler for status changes
  const handleStatusChange = useCallback((value: string) => {
    setFilters((prev) => ({
      ...prev,
      status: value,
    }));
  }, []);

  // Handler for clearing filters
  const handleClearFilters = useCallback(() => {
    setFilters({
      search: '',
      status: 'all',
      sortBy: 'updated_at',
      sortDirection: 'desc',
    });
  }, []);

  // Navigation handlers
  const handleFirmClick = useCallback(
    (firmId: string) => {
      navigate(`/firms/${firmId}`);
    },
    [navigate],
  );

  const handleEditClick = useCallback(
    (e: React.MouseEvent, firmId: string) => {
      navigate(`/firms/${firmId}?tab=edit`);
    },
    [navigate],
  );

  const handleCreateClick = useCallback(() => {
    navigate('/firms/create');
  }, [navigate]);

  return (
    <div className="bg-white shadow rounded-lg">
      <FirmsTable
        firms={firms}
        isLoading={isLoading}
        searchValue={filters.search}
        statusFilter={filters.status || 'all'}
        onSearchChange={handleSearchChange}
        onStatusChange={handleStatusChange}
        onClearFilters={handleClearFilters}
        onFirmClick={handleFirmClick}
        onEditClick={handleEditClick}
        onCreateClick={handleCreateClick}
      />
    </div>
  );
};
